var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "card card-chat-booking float-left ml-3" }, [
    _c("div", { staticClass: "card-body" }, [
      _c("div", { staticClass: "mb-3" }, [
        _c("b", [_vm._v(_vm._s(_vm.$t("message.menu.payment_method")))])
      ]),
      _vm._v(" "),
      _vm.bookingData
        ? _c("div", [
            _c(
              "a",
              {
                staticClass: "text-secondary",
                attrs: { href: "" },
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    return _vm.sendMessage(0)
                  }
                }
              },
              [
                _c("div", { staticClass: "card border-secondary" }, [
                  _c("div", { staticClass: "card-body p-3" }, [
                    _c("i", { staticClass: "fal fa-credit-card" }),
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.$t("message.payment_method.credit_debit_card")
                        ) +
                        "\n          "
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "a",
              {
                staticClass: "text-secondary",
                attrs: { href: "" },
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    return _vm.sendMessage(1)
                  }
                }
              },
              [
                _c("div", { staticClass: "card border-secondary" }, [
                  _c("div", { staticClass: "card-body p-3" }, [
                    _c("i", { staticClass: "fal fa-money-bill-wave" }),
                    _vm._v(
                      " " +
                        _vm._s(_vm.$t("message.payment_method.bank_transfer")) +
                        "\n          "
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "a",
              {
                staticClass: "text-secondary",
                attrs: { href: "" },
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    return _vm.sendMessage(2)
                  }
                }
              },
              [
                _c("div", { staticClass: "card border-secondary mb-0" }, [
                  _c("div", { staticClass: "card-body px-3 py-2 text-dark" }, [
                    _c("i", { staticClass: "fal fa-qrcode" }),
                    _vm._v(
                      " " +
                        _vm._s(_vm.$t("message.payment_method.promptpay")) +
                        "\n            "
                    ),
                    _c("img", {
                      staticClass: "rounded ml-2",
                      attrs: {
                        src: "/static/img/thai_qr_payment.png",
                        height: "40"
                      }
                    })
                  ])
                ])
              ]
            )
          ])
        : _vm._e()
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2996f56b", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2996f56b","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chatBooking/components/PaymentMethodMessage.vue
// module id = 2229
// module chunks = 0